/**
 * @file SystemMessages Component
 * @author Heino Lenting
 */
import { SystemMessagesService } from '../system-messages.service';
/**
 * SystemMessages Component
 */
var SystemMessagesComponent = /** @class */ (function () {
    /**
     * Constructs a SystemMessagesComponent instance.
     * @param systemMessagesService The system messages service
     */
    function SystemMessagesComponent(systemMessagesService) {
        this.systemMessagesService = systemMessagesService;
    }
    return SystemMessagesComponent;
}());
export { SystemMessagesComponent };
